import * as React from 'react';
import { SVGProps } from 'react';

const QRCode = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" {...props}>
    <path
      fill="#0F0F10"
      fillRule="evenodd"
      d="M2.4 3.2a.8.8 0 0 1 .8-.8h2.4a.8.8 0 0 1 .8.8v2.4a.8.8 0 0 1-.8.8H3.2a.8.8 0 0 1-.8-.8V3.2ZM4 4.8V4h.8v.8H4ZM2.4 10.4a.8.8 0 0 1 .8-.8h2.4a.8.8 0 0 1 .8.8v2.4a.8.8 0 0 1-.8.8H3.2a.8.8 0 0 1-.8-.8v-2.4ZM4 12v-.8h.8v.8H4ZM10.4 2.4a.8.8 0 0 0-.8.8v2.4a.8.8 0 0 0 .8.8h2.4a.8.8 0 0 0 .8-.8V3.2a.8.8 0 0 0-.8-.8h-2.4Zm.8 1.6v.8h.8V4h-.8Z"
      clipRule="evenodd"
    />
    <path
      fill="#0F0F10"
      d="M8.8 3.2a.8.8 0 1 0-1.6 0V4a.8.8 0 0 0 1.6 0v-.8ZM8 5.6a.8.8 0 0 1 .8.8v.8h1.6a.8.8 0 0 1 0 1.6H8a.8.8 0 0 1-.8-.8V6.4a.8.8 0 0 1 .8-.8ZM12.8 7.2a.8.8 0 1 0 0 1.6.8.8 0 0 0 0-1.6ZM7.2 10.4a.8.8 0 0 1 .8-.8h.8a.8.8 0 1 1 0 1.6v1.6a.8.8 0 0 1-1.6 0v-2.4ZM5.6 8.8a.8.8 0 1 0 0-1.6H3.2a.8.8 0 1 0 0 1.6h2.4ZM13.6 10.4a.8.8 0 0 1-.8.8h-1.6a.8.8 0 0 1 0-1.6h1.6a.8.8 0 0 1 .8.8ZM12.8 13.6a.8.8 0 0 0 0-1.6h-2.4a.8.8 0 0 0 0 1.6h2.4Z"
    />
  </svg>
);
export default QRCode;
